import axios from "@/api/axiosInstance";
import type {
  SignSubscriptionAgreementRequest,
  SignSubscriptionAgreementResponse,
} from "./types";

export const signSubscriptionAgreement = async (
  request: SignSubscriptionAgreementRequest,
): Promise<SignSubscriptionAgreementResponse> => {
  const response = await axios.post<SignSubscriptionAgreementResponse>(
    "/api/private/subscription-agreement/sign",
    request,
  );
  return response.data;
};
